
import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Select, Input, Tabs, Space } from 'antd';
import { CheckCircleOutlined, HomeOutlined, CloseCircleOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, CopyOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import Message from '../../component/message/message';
import './wilProgramme.css';

const { TabPane } = Tabs;
const { Option } = Select;

const WilProgramme = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramSegmentList, setParamSegmentList] = useState([]);
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [isUpload, setIsUpload] = useState(false);
    const [isClone, setIsClone] = useState(false);
    const tableColumns = {
    }
    const options = [
        { label: "Design and Architecture", value: "DA" },
        { label: "Sports and Recreation", value: "SR" },
    ]


    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setTables([
            { id: 1, programmeCode: "COMPUTING", programmeName: "Computing", launchYear: "2024", department: "DA" }
        ]);
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setFlag("add");
        setTabIndex("2");
    }

    const clone = () => {
        if (!selectedRowKeys || selectedRowKeys.length === 0) {
            errFrameShow("error", "Please select at least one record.");
            return;
        }
        setIsClone(true);
    }

    const cloneClose = (flag) => {
        setIsClone(false);
    }

    const download = () => {
        setIsUpload(true)
    }

    const uploadClose = (flag) => {
        setIsUpload(false);
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            programmeCode: model.programmeCode ?? '',
            programmeName: model.programmeName ?? '',
            launchYear: model.launchYear ?? '',
            department: model.department ?? '',
        });
    }


    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const downloadExcel = () => {
    }

    const onSave = (values) => {
        messageShowHandler();
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const update = (model, e) => {
        e.stopPropagation();
        initForm(model)
        setFlag("edit");
        setTabIndex("2");
    }


    const deleteOne = (model, e) => {
        e.stopPropagation();
        setParamModel(model)
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([])
    }

    const columns = [
        {
            title: "Programme Code",
            dataIndex: 'programmeCode',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'programmeCode') },
        },
        {
            title: "Programme Name",
            dataIndex: 'programmeName',
            className: 'tableWidth25',
        },
        {
            title: "Launch Year",
            dataIndex: 'launchYear',
            className: 'tableWidth12',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'launchYear') },
        },
        {
            title: "Department",
            dataIndex: 'department',
            className: 'tableWidth20',
            render: (text) => 'Design and Architecture'
        },
        {
            title: "Operation",
            dataIndex: '',
            fixed: 'right',
            className: 'tableWidth20 sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> Edit</div>
                <div className='sysOperation' onClick={(e) => update(record, e)}><CopyOutlined /> Clone</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> Delete</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <div id="container" className="template wilProgramme">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="List">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme Code</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Programme Code" value={searchModel.progCode}
                                            onChange={(e) => searchChange('progCode', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Programme Name" value={searchModel.progName}
                                            onChange={(e) => searchChange('progName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Launch Year</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Launch Year" value={searchModel.launchYear}
                                            onChange={(e) => searchChange('launchYear', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Department</div>
                                    <div className="sysSerchInput">
                                        <Select className='sysSelect' placeholder="Department" value={searchModel.department}>
                                            <Option value=''></Option>
                                            {options.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>Add</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowKey="id"
                                    scroll={{ x: 1300 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"WIL Programme"} key="2" forceRender={true}>
                            <Form form={form} onFinish={onSave}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Programme Code</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="programmeCode"
                                            >
                                                <Input type="text" placeholder="Programme Code" maxLength={15} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Programme Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="programmeName"
                                            >
                                                <Input type="text" placeholder="Programme Name" maxLength={100} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Launch Year</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="launchYear"
                                            >
                                                <Input type="text" placeholder="Launch Year" maxLength={4} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Department</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="department"
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {options.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>Save</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>Cancel</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default WilProgramme;